/**
 * Small status pill for the Intake tab (plan §11 tab 1). Color is paired
 * with the label text itself (never color alone, per the design skill).
 */
import type { IntakeStatus } from '../../api/intake';

const INTAKE_STATUS_META: Record<IntakeStatus, { label: string; cls: string }> = {
  new: { label: 'New', cls: 'bg-primary-50 text-primary-700 dark:bg-primary-900/20 dark:text-primary-400' },
  approved: { label: 'Approved', cls: 'bg-amber-50 text-amber-700 dark:bg-amber-900/20 dark:text-amber-400' },
  ingested: { label: 'Ingested', cls: 'bg-green-50 text-green-700 dark:bg-green-900/20 dark:text-green-400' },
  ignored: { label: 'Ignored', cls: 'bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-300' },
  failed: { label: 'Failed', cls: 'bg-red-50 text-red-700 dark:bg-red-900/20 dark:text-red-400' },
};

export function IntakeStatusPill({ status }: { status: IntakeStatus }) {
  const meta = INTAKE_STATUS_META[status] ?? { label: status, cls: 'bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-300' };
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium whitespace-nowrap ${meta.cls}`}>
      {meta.label}
    </span>
  );
}

export default IntakeStatusPill;
